import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class ForgotPasswordMetaModel extends FormMetaModel {
    constructor() {
        super('ForgotPassword', ROUTE_PATH.forgotPassword , '', 1);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const email = new SmMetaInputModel(
            'email',
            'email',
            'input',
            true,
            'form-control col-12 ',
            1,
            1,
            'Email ID',
            'text',
            '',
            false,
            true,
            true,
            false,
            50,
            5,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            "",
            "",
            false,
            [],
            false,
            "",
            false,
            true,
            false,
            true
        );
        
     

        const Submit = new SmBtnMetaModel('SUBMIT', 'primary', true, false, true, false);

        return {
            formInfo,
            email,
            Submit,
            
        };
    }
}